export const CLASS_NAMES = {
  userAvatar: 'header-user-avatar',
  userMenu: 'header-user-menu',
  searchButton: 'header-search-button',
  notificationsButton: 'header-notifications-button',
  inviteButton: 'header-invite-button',
  settingsLink: 'header-settings-link',
  logoutButton: 'header-logout-button',
} as const;
